import * as React from "react"
import { graphql, StaticQuery } from "gatsby";
import LinkCustom from '../components/TransitionLinks/LinkCustom';

export default (props) => (
  <StaticQuery
    query={graphql`
      query storynav {
        allMarkdownRemark(
          sort: { order: ASC, fields: [frontmatter___name] }
          limit: 1000
        ) {
          nodes {
            frontmatter {
              path
            }
          }
          totalCount
        }
      }
    `}
    render={data => {
      
      const stories = data.allMarkdownRemark.nodes;
      const count = data.allMarkdownRemark.totalCount - 1;

      var currentPath = props.currentPath;

      var pos = stories.map(function(story, index) { return story.frontmatter.path; }).indexOf(currentPath);

      var prevPos = pos - 1;
      var nextPos = pos + 1;
      
      var prevLinktext = 'Previous Story';
      var nextLinktext = 'Next Story';

      if (pos == 0) {
        var prevLink = '/all-stories';
        var prevLinktext = 'Back to All Stories';

        var nextLink = stories[nextPos].frontmatter.path;
      } else if (pos == count) {
        var nextLink = '/comments';
        var nextLinktext = 'Next: Comments';

        var prevLink = stories[prevPos].frontmatter.path;
      } else {
        var prevLink = stories[prevPos].frontmatter.path;
        var nextLink = stories[nextPos].frontmatter.path;
      }

      

      


      return (
        <div className="post-nav">
          <LinkCustom className="post-nav-link post-nav-prev" effect="slideRight" length={2} url={prevLink}>
            <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"  role="img" aria-labelledby="back-arrow-title">
              <title id="back-arrow-title">Back Arrow</title>
              <path role="presentation" d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"/>
            </svg>
            {prevLinktext}
          </LinkCustom>
          <LinkCustom className="post-nav-link post-nav-next" effect="slideLeft" length={2} url={nextLink}>
            {nextLinktext}
            <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512"  role="img" aria-labelledby="next-arrow-title">
              <title id="next-arrow-title">Next Arrow</title>
              <path role="presentation" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"/>
            </svg>
          </LinkCustom>
        </div>
      )
        

    }}
  />
)